import React, { useEffect, useRef, useState } from "react";
import styles from "./home.module.css";
import ContainerLanding from "components/container-landing";
import AmandaFinnertyImage from "assets/images/Testimonial-Amanda.jpg";
import MarianaZapataImage from "assets/images/mariana-zapata-image.webp";
import instagramLogo from "assets/images/instagram-logo.svg";
import linkedInLogo from "assets/images/linkedin-logo.svg";
import youtubeLogo from "assets/images/youtube-icon.svg";
import procurementLogImage from "assets/images/procurement-log-1.webp";
import dashboardImage from "assets/images/dashboard-1.webp";
import customReportImage from "assets/images/custom-report-1.webp";
import { Link } from "react-router-dom";
import { Modal } from "react-bootstrap";
import { PlayCircleFilled } from "@ant-design/icons";
import Card from "./card";
import TextLoop from "react-text-loop";
import { Swiper, SwiperSlide } from "swiper/react";
import { EffectCoverflow, Pagination } from "swiper/modules";
import TestimonialCard from "./testimonial-card";
import ContactUsComponent from "components/contact-us-component";
import "swiper/css";
import "swiper/css/effect-coverflow";
import "swiper/css/pagination";
import { Button } from "antd";
import { useLocation } from "react-router-dom";

// Custom CSS for white pagination dots
const customStyles = `
  .swiper-pagination-bullet {
    background-color: white;
    opacity: 0.5;
  }
  .swiper-pagination-bullet-active {
    background-color: white;
    opacity: 1;
  }
  
  .swiper-slide {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
  }
  
  .swiper-slide-active .slide-content {
    opacity: 1;
    visibility: visible;
    transition: opacity 0.3s ease;
  }
  
  .swiper-slide:not(.swiper-slide-active) .slide-content {
    opacity: 0;
    visibility: hidden;
    transition: opacity 0.3s ease;
  }
`;

const Home = () => {
  const currentYear = new Date().getFullYear();
  const [showPrivacyModal, setShowPrivacyModal] = useState(false);
  const [watchVideoModal, setWatchVideoModal] = useState(false);

  const handleClosePrivacyModal = () => setShowPrivacyModal(false);
  const handleCloseVideoModal = () => setWatchVideoModal(false);

  const slides = [
    {
      image: customReportImage,
      title: "Custom Reporting",
      subtitle:
        "Tailor a report to your specific reporting needs and challenges.",
    },
    {
      image: procurementLogImage,
      title: "Procurement Log",
      subtitle: "That familiar Excel feel, tailored to construction.",
    },
    {
      image: dashboardImage,
      title: "Project Dashboard",
      subtitle: "Quickly visualize your project's performance.",
    },
  ];

  const [initialSlide] = useState(0);

  useEffect(() => {
    // Load the HubSpot meetings embed script after component mounts
    const script = document.createElement("script");
    script.src =
      "https://static.hsappstatic.net/MeetingsEmbed/ex/MeetingsEmbedCode.js";
    script.async = true;
    document.body.appendChild(script);

    return () => {
      // Cleanup the script if component unmounts (optional)
      document.body.removeChild(script);
    };
  }, []);

  const videoRef = useRef(null);
  const [hasPlayed, setHasPlayed] = useState(false);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting && !hasPlayed) {
          videoRef.current.play();
          setHasPlayed(true); // ensures it starts once
        }
      },
      { threshold: 0.5 } // 50% of video must be visible
    );

    if (videoRef.current) {
      observer.observe(videoRef.current);
    }

    return () => {
      if (videoRef.current) {
        observer.unobserve(videoRef.current);
      }
    };
  }, [hasPlayed]);

  const location = useLocation(); // Get current location

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const videoParam = params.get("video");

    if (videoParam === "true") {
      setWatchVideoModal(true);
    }
  }, [location.search]);

  return (
    <div>
      {/* <HomeSlider /> */}

      <div className="bg-black text-white p-5">
        <ContainerLanding
          style={{ height: "90vh", padding: "0px" }}
          className="d-flex justify-content-center align-items-center"
        >
          <div className="d-flex flex-column justify-content-center align-items-center">
            <div className="d-flex flex-column align-items-center align-items-md-start gap-0">
              <div
                className="d-flex w-100 flex-column justify-content-center align-items-center text-center"
                style={{ minWidth: "320px", maxWidth: "700px" }}
              >
                <TextLoop
                  interval={8000}
                  mask={true}
                  style={{ minWidth: "100vw" }}
                  springConfig={{ stiffness: 100, damping: 15 }}
                >
                  <div
                    className=" w-100 h-auto d-flex text-center flex-column justify-content-center align-items-center gap-0"
                    style={{ minWidth: "100vw" }}
                  >
                    <p
                      className={`${styles.homeHeader} text-center text-wrap fw-bold m-0 p-0 lh-sm`}
                    >
                      Procurement with that familiar <br /> spreadsheet feel,
                      but smarter.
                    </p>
                    <p
                      className={`${styles.homeSubHeader} text-center opacity-50 m-0 p-0`}
                    >
                      No more duct-taped spreadsheets. <br /> You focus on
                      building. We make sure materials are at your fingertips.
                    </p>
                  </div>

                  <div
                    className=" w-100 h-auto d-flex text-center flex-column justify-content-center align-items-center gap-0"
                    style={{ minWidth: "100vw" }}
                  >
                    <p
                      className={`${styles.homeHeader} text-center text-wrap fw-bold m-0 p-0 lh-sm`}
                    >
                      Built for builders, <br /> designed to simplify.
                    </p>
                    <p
                      className={`${styles.homeSubHeader} text-center opacity-50 m-0 p-0`}
                    >
                      Streamline procurement, gain visibility across teams, and
                      keep projects <br /> moving - faster, smoother, and with
                      fewer surprises.
                    </p>
                  </div>

                  <div
                    className=" w-100 h-auto d-flex text-center flex-column justify-content-center align-items-center gap-0"
                    style={{ minWidth: "100vw" }}
                  >
                    <p
                      className={`${styles.homeHeader} text-center text-wrap fw-bold m-0 p-0 lh-sm`}
                    >
                      Built for GCs. <br /> Made to Move Projects.
                    </p>

                    <p
                      className={`${styles.homeSubHeader} text-center opacity-50 m-0 p-0`}
                    >
                      One platform to connect procurement, submittals,
                      schedules, and the <br /> chaos in between.
                    </p>
                  </div>
                </TextLoop>
              </div>
            </div>

            <div className="d-flex flex-row gap-3">
              <a className={`${styles.bookDemoBtn}`} href={"#book_demo"}>
                Book a Demo
              </a>
              <Button
                // href="https://www.youtube.com/watch?v=FcNVZG3kpbc"
                // href="https://www.loom.com/share/cce74a131d1e48dabf184c1b4c414c7c?sid=47d2a7fc-445a-4c64-982b-e22b72883769"
                // target="_blank"
                // rel="noreferrer"
                onClick={() => {
                  setWatchVideoModal(true);
                }}
                className={`${styles.watchVideoBtn}`}
              >
                Watch the Video
                <PlayCircleFilled className="opacity-50" />
              </Button>
            </div>
          </div>
        </ContainerLanding>
      </div>

      {/* Video Modal */}
      <Modal
        show={watchVideoModal}
        centered
        onHide={handleCloseVideoModal}
        width={1000}
        style={{ backgroundColor: "rgba(0, 0, 0, 0.8)" }}
        size="lg"
      >
        <Modal.Body
          style={{
            backgroundColor: "black",
          }}
        >
          <video
            autoPlay
            controls
            playsInline
            preload="auto"
            style={{ width: "100%", height: "auto" }}
            className="rounded-3"
          >
            {/* <source src="/videos/introductionary-video.mp4" type="video/mp4" /> */}
            <source src="/videos/final-website-video.mp4" type="video/mp4" />
            Your browser does not support the video tag.
          </video>
        </Modal.Body>
      </Modal>

      <div className="bg-white text-black p-3 pt-5" id="how_it_works">
        <ContainerLanding
          style={{ height: "auto", padding: "30px 0px 90px 0px" }}
          className=" d-flex justify-content-start"
        >
          <div className="d-flex  flex-column w-100">
            <div className=" pt-2 pb-2">
              <h2 className=" fw-bold">How It Works</h2>
            </div>
            <div className=" d-flex flex-column flex-md-row gap-5 justify-content-between align-items-center">
              <Card
                number={"01"}
                title={"Connect to Procore"}
                subTitle={"Seamlessly sync Koncurent with Procore"}
              />
              <Card
                number={"02"}
                title={"Push or Pull Submittals"}
                subTitle={
                  "Import your Procore Submittals or create and post them from Koncurent"
                }
              />
              <Card
                number={"03"}
                title={"Connect Schedule Data"}
                subTitle={
                  "Link procurement items to schedule tasks—Koncurent handles the rest"
                }
              />
            </div>
          </div>
        </ContainerLanding>
      </div>

      <div
        id="features"
        className=" w-100  pb-5 bg-black d-flex flex-column justify-content-center align-items-center"
        style={{ minHeight: "100vh", paddingTop: "100px" }}
      >
        <style>{customStyles}</style>

        <div className=" d-flex w-100 flex-column justify-content-center align-items-center text-center text-white pb-3">
          <h1 className=" fw-bold">Some of our Capabilities</h1>
        </div>

        <Swiper
          modules={[EffectCoverflow, Pagination]}
          effect="coverflow"
          grabCursor={true}
          centeredSlides={true}
          initialSlide={1}
          slidesPerView={3}
          spaceBetween={30}
          // loop={true}
          slideToClickedSlide={true}
          loopedSlides={slides.length + 1}
          coverflowEffect={{
            rotate: 0,
            stretch: 0,
            depth: 100,
            modifier: 2.5,
            slideShadows: false,
          }}
          pagination={{
            clickable: true,
          }}
          style={{
            paddingBottom: "50px",
            // paddingTop: "20px",
            width: "100%",
            display: "flex",
            justifyContent: "center",
          }}
        >
          {slides.map((slide, index) => (
            <SwiperSlide
              key={index}
              style={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <div
                style={{
                  display: "flex",
                  justifyContent: "center",
                  width: "100%",
                }}
              >
                <img
                  src={slide.image}
                  alt={slide.title}
                  style={{
                    width: "70vw",
                    maxWidth: "830px",
                    borderRadius: "10px",
                    // boxShadow: "0 4px 20px rgba(0,0,0,0.1)",
                    objectFit: "contain",
                  }}
                />
              </div>
              <div
                className="slide-content d-flex flex-column w-100 text-white text-center justify-content-center"
                style={{ minWidth: "420px" }}
              >
                <h3 className="fw-bold p-0 m-0" style={{ marginTop: "1rem" }}>
                  {slide.title}
                </h3>
                <p
                  className="opacity-50 p-0 m-0"
                  style={{ margin: "0.5rem 0" }}
                >
                  {slide.subtitle}
                </p>
              </div>
            </SwiperSlide>
          ))}
        </Swiper>
      </div>

      <div
        className="bg-white text-black w-100"
        id="integrations"
        style={{ padding: "60px 10px" }}
      >
        <ContainerLanding
          style={{ height: "auto", padding: "60px 0px 0px 0px" }}
          className=" d-flex justify-content-center align-items-center w-100"
        >
          <div className="d-flex  flex-column flex-md-row  justify-content-center align-items-center gap-3 w-100 ">
            <div
              className=" py-4 w-100 px-4 px-md-0"
              style={{ minWidth: "400px" }}
            >
              <h1 className=" fw-bold mb-0 pb-0 ">
                Seamlessly integrate with Procore.{" "}
                <span style={{ color: "#2CC4F3" }}>
                  Sync submittals and specs in seconds.
                </span>
              </h1>
              <p className=" mt-3 p-0 opacity-75 fs-5 ">
                Build your live Procurement Tracking log with your team in
                minutes. Get real-time updates and eliminate double entry.
                Saving time and reducing errors. Simplify procurement to keep
                projects on schedule.
              </p>
            </div>
            <div className=" d-flex w-100 justify-content-center align-items-center">
              {/* <video
                autoPlay
                loop
                muted
                playsInline
                preload="auto"
                style={{ width: "80%", height: "auto", objectFit: "cover" }}
                className="rounded-3"
              >
                <source
                  src="/videos/homepage-video-zoom.mp4"
                  type="video/mp4"
                />
                Your browser does not support the video tag.
              </video> */}
              <video
                ref={videoRef}
                muted
                loop
                playsInline
                preload="auto"
                style={{ width: "100%", height: "auto", objectFit: "cover" }}
                className="rounded-3"
              >
                <source
                  src="/videos/homepage-video-zoom.mp4"
                  type="video/mp4"
                />
                Your browser does not support the video tag.
              </video>
            </div>
          </div>
        </ContainerLanding>
      </div>

      <div
        className=" text-black"
        id="testimonials"
        style={{
          background: "#F9FAFB",
          paddingTop: "100px",
          paddingBottom: "100px",
        }}
      >
        <ContainerLanding
          style={{
            height: "auto",
          }}
          className=" d-flex justify-content-center"
        >
          <div className="d-flex flex-column justify-content-center w-100">
            <div className=" pt-2 pb-4 d-flex justify-content-center">
              <h2 className=" fw-bold">Don't take our word for it</h2>
            </div>
            <div className=" d-flex flex-column flex-lg-row gap-5 align-items-center w-75 align-self-center">
              <TestimonialCard
                Body={
                  "Koncurent provides us with an elegant and collaborative solution that will help standardize the way we do procurement."
                }
                Name={"Amanda Finnerty"}
                Position={
                  "Director of Technology & Process at Commodore Builders"
                }
                Avatar={AmandaFinnertyImage}
              />
              <TestimonialCard
                Body={
                  "Koncurent is incredibly easy to use and has streamlined our procurement workflow from day one. The best part is how seamlessly it communicates with Procore in real time, keeping everything perfectly in sync without any extra effort."
                }
                Name={"Mariana Zapata"}
                Position={"Assistant Project Manager"}
                Avatar={MarianaZapataImage}
              />
            </div>
          </div>
        </ContainerLanding>
      </div>

      <div className="bg-black text-white p-3" id="book_demo">
        <ContainerLanding>
          <div className="d-flex flex-md-row flex-column gap-5">
            <div className=" w-100 d-flex flex-column justify-content-center align-items-center">
              {/* <ContactUsComponent /> */}
              <h2 className=" py-4 fw-bold">Book a Demo</h2>
              <div
                className=" d-flex justify-content-center align-items-center w-100 meetings-iframe-container"
                data-src="https://meetings-na2.hubspot.com/kevin-watters?embed=true"
              />
            </div>
          </div>
        </ContainerLanding>
      </div>

      {/* Privacy Notice Modal */}
      <Modal show={showPrivacyModal} onHide={handleClosePrivacyModal}>
        <Modal.Header closeButton>
          <Modal.Title>Privacy Notice</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          This Privacy Policy explains our practices regarding the collection,
          use, and disclosure of information that we receive from users of our
          website and services.
          <br /> 1. Information We Collect We collect information that you
          provide to us, such as your name, email address, postal address, and
          phone number when you register for our services, make a purchase, or
          otherwise communicate with us. We may also collect information about
          your use of our website and services, such as your IP address, browser
          type, and device ID.
          <br /> 2. How We Use Your Information We use your information to
          provide our services to you, to communicate with you about our
          services, and to improve our website and services. We may also use
          your information to send you marketing communications about our
          services, unless you opt out of such communications.
          <br /> 3. Sharing Your Information We do not sell or rent your
          personal information to third parties. We may share your information
          with our third-party service providers who help us to provide our
          services or process payments. We may also share your information if
          required by law or to protect our rights or the rights of others.
          <br /> 4. Security We take reasonable measures to protect your
          information from unauthorized access, use, or disclosure. However, no
          method of transmission over the Internet or electronic storage is 100%
          secure, and we cannot guarantee the absolute security of your
          information.
          <br /> 5. Your Choices You may choose to opt out of receiving
          marketing communications from us at any time by following the
          instructions in the communications. You may also access, correct, or
          delete your personal information by contacting us.
          <br /> 6. Children's Privacy Our website and services are not intended
          for use by children under the age of 13. We do not knowingly collect
          personal information from children under 13. If we become aware that
          we have collected personal information from a child under 13, we will
          take steps to delete the information as soon as possible.
          <br /> 7. Changes to This Privacy Policy We may update this Privacy
          Policy from time to time. If we make material changes to this Privacy
          Policy, we will notify you by email or by posting a notice on our
          website.
          <br /> 8. Contact Us If you have any questions or concerns about our
          Privacy Policy, please contact us.
        </Modal.Body>
      </Modal>

      <div className=" d-flex justify-content-center justify-content-md-start align-items-center bg-black text-white">
        <footer className="d-flex flex-column-reverse flex-md-row justify-content-center pb-3 justify-content-center gap-5 w-100 gap-1 px-0 px-md-5">
          <div className="d-flex flex-row  gap-2 justify-content-center align-items-center">
            <p
              className="opacity-75 pointer m-0 p-0"
              onClick={() => setShowPrivacyModal(true)}
            >
              Privacy Notice
            </p>

            <span className="opacity-50 m-0 p-0"> | </span>
            <p className="opacity-50 m-0 p-0">
              © {currentYear} All rights reserved.
            </p>
          </div>

          <div className=" d-flex flex-column flex-md-row gap-2">
            <div className=" d-flex justify-content-center align-items-center w-100">
              <h5 className=" fw-bold m-0 p-0">GET SOCIAL</h5>
            </div>
            <div className=" d-flex justify-content-center align-items-center gap-2">
              <a
                href="https://www.linkedin.com/company/koncurent"
                target="_blank"
                rel="noreferrer"
              >
                <img src={linkedInLogo} width={50} alt="Linkedin-logo" />
              </a>

              {/* <a
                href="https://www.instagram.com/koncurenttech/"
                target="_blank"
                rel="noreferrer"
              >
                <img src={instagramLogo} width={35} alt="Instagram-logo" />
              </a> */}

              {/* <a
                href="https://www.youtube.com/watch?v=FcNVZG3kpbc"
                target="_blank"
                rel="noreferrer"
              >
                <img
                  src={youtubeLogo}
                  width={50}
                  className=" ms-2"
                  alt="Youtube-logo"
                />
              </a> */}
            </div>
          </div>
        </footer>
      </div>
      {/* <OurPlatform /> */}
    </div>
  );
};

export default Home;
